/**
 * @desciprtion for social-media link list. If some icons has dark background-color, use white icons.
 * .\modules\kiha-link-highlight\kiha-link-highlight-web\src\main\resources\META-INF\resources\templates\ftl\social_media.ftl
 */

 addEventListener("DOMContentLoaded", function () {
	if (document.querySelector(".social-media-highlight")) {
	  const socialMediaHighLight = document.querySelectorAll(".social-media-highlight");
  
	  /**
	   * @description based on luminocity, check if backround-color is dark
	   * @param { String } bgColor background-color as rgb-value
	   * @returns { Boolean } true, if bgColor is dark
	   */
	  function calculateDarkness(bgColor) {
		let red;
		let green;
		let blue;
		let colorHSP;
  
		//getPropertyValue returns rgb, should be modified to HSP to get luminosity
		if (bgColor.match(/^rgb/)) {
		  bgColor = bgColor.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
  
		  red = bgColor[1];
		  green = bgColor[2];
		  blue = bgColor[3];
		} else {
		  return "light";
		}
  
		// HSP horror. Reference: http://alienryderflex.com/hsp.html
		colorHSP = Math.sqrt(0.299 * (red * red) + 0.587 * (green * green) + 0.114 * (blue * blue));
  
		// Based on color luminosity, do visuals
		if (colorHSP > 127.5) {
		  return false;
		} else {
		  return true;
		}
	  }
  
	  /**
	   *
	   * @param { Array.<Element> } elem element to check
	   * @returns { String } rgb value
	   */
	  //return first parent with bg, which differs white or none (if exists)
	  function findParentWithBackgroundColor(elem) {
		let currElement = elem.parentElement;
		let elStyle;
		let bgColor = "rgba(255, 255, 255, 1)";
		while (currElement) {
		  elStyle = window.getComputedStyle(currElement);
		  if (elStyle.getPropertyValue("background-color")) {
			if (elStyle.getPropertyValue("background-color") !== "rgba(0, 0, 0, 0)") {
			  if (elStyle.getPropertyValue("background-color") !== "rgb(255, 255, 255)") {
				bgColor = elStyle.getPropertyValue("background-color");
				break;
			  }
			}
		  }
		  currElement = currElement.parentElement;
		  if (currElement.id === "content") {
			break;
		  }
		}
		return bgColor;
	  }
	  /**
	   * @description main loop: if there's dark bg, use light .svg's
	   */
	  for (let i = 0; i < socialMediaHighLight.length; i++) {
		const bgColor = findParentWithBackgroundColor(socialMediaHighLight[i]);
		const darkFields = socialMediaHighLight[i].querySelectorAll(".some-dark-bg");
		const lightFields = socialMediaHighLight[i].querySelectorAll(".some-light-bg");
  
		if (calculateDarkness(bgColor)) {  
		  if(calculateDarkness(bgColor)){
			  for (let j = 0; j < darkFields.length; j++) {
				darkFields[j].classList.remove("d-none");
			  }
			  for(let j = 0; j < lightFields.length; j++) {
				  lightFields[j].classList.add("d-none");
			  }
		  } else {
			  for (let j = 0; j < lightFields.length; j++) {
				lightFields[j].classList.remove("d-none");
			  }
			  for (let j = 0; j < darkFields.length; j++) {
				  darkFields[j].classList.add("d-none");
			  }
		  }
		}
	  }
	}
  });
  